export type IDesignTier = 'phone' | 'tablet' | 'desktop';

export const DESIGN_TABLET_MIN = 720;
export const DESIGN_DESKTOP_MIN = 1024;
export const DESIGN_FORM_WIDTH = 720;
export const DESIGN_PREVIEW_WIDTH = 400;
/** `V2CanvasPage` `.cp-aside.is-docked` margin (tw-ml-4, `V2CanvasPage.vue:193-197`). */
const DESIGN_ASIDE_GAP = 16;
export const PHONE_VIEWPORT = { width: 390, height: 844 } as const;
export const PHONE_BEZEL = 8;

export interface IDesignColumns {
  tier: IDesignTier;
  gutter: 16 | 24;
  /** `V2CanvasPage` `maxWidth`: the form alone, or form + docked preview. */
  maxWidth: number;
  previewDocked: boolean;
  /** null = the preview is a sheet. */
  asideWidth: number | null;
}

export function designTier(pageWidth: number): IDesignTier {
  if (pageWidth < DESIGN_TABLET_MIN) return 'phone';
  if (pageWidth < DESIGN_DESKTOP_MIN) return 'tablet';
  return 'desktop';
}

/** One right-hand panel at a time: with the «Asistente» docked, the preview is a sheet (the Menú page rule, `catalog-layout.ts:83`). */
export function designColumns(
  pageWidth: number,
  assistantDocked: boolean
): IDesignColumns {
  const tier = designTier(pageWidth);
  const previewDocked = tier === 'desktop' && !assistantDocked;
  return {
    tier,
    gutter: tier === 'phone' ? 16 : 24,
    maxWidth: previewDocked
      ? DESIGN_FORM_WIDTH + DESIGN_ASIDE_GAP + DESIGN_PREVIEW_WIDTH
      : DESIGN_FORM_WIDTH,
    previewDocked,
    asideWidth: previewDocked ? DESIGN_PREVIEW_WIDTH : null,
  };
}

export interface IPhoneFrameSize {
  scale: number;
  /** Outer size, bezel included, in px. */
  width: number;
  height: number;
}

/** The 390×844 phone (plus bezel) scaled down to fit the box; null while the box has no size. */
export function fitPhoneFrame(
  boxWidth: number,
  boxHeight: number
): IPhoneFrameSize | null {
  if (!(boxWidth > 0) || !(boxHeight > 0)) return null;
  const scale = Math.min(
    1,
    (boxWidth - 2 * PHONE_BEZEL) / PHONE_VIEWPORT.width,
    (boxHeight - 2 * PHONE_BEZEL) / PHONE_VIEWPORT.height
  );
  if (!(scale > 0)) return null;
  return {
    scale,
    width: Math.round(PHONE_VIEWPORT.width * scale) + 2 * PHONE_BEZEL,
    height: Math.round(PHONE_VIEWPORT.height * scale) + 2 * PHONE_BEZEL,
  };
}
